<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onRefresh()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <section class="tw-w-full">
      <fieldset class="tw-h-full">
        <legend class="tw-flex-center">
          {{ title | translate }}
        </legend>
        <!-- form -->
        <form [formGroup]="form" autocomplete="off">
          <div class="row">
            <!-- General -->
            <details class="tw-px-4 tw-mt-5 tw-w-full" [open]="true">
              <summary
                class="active:tw-outline-none dark:tw-text-gray-300 focus:tw-outline-none tw-font-bold tw-mb-2 tw-text-[18px] tw-text-primary-700 tw-text-right"
              >
                {{
                  pageVocabs + "legends.competitionSpecifications" | translate
                }}
              </summary>

              <div class="row tw-mt-8 xl:tw-px-36 lg:tw-px-14 sm:tw-px-10">
                <!-- title -->
                <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                  <form-field
                    class="tw-w-full"
                    [(value)]="model.title"
                    [control]="form?.get('title')"
                    label="common.title"
                  >
                  </form-field>
                </div>

                <!-- privateNumberId -->
                <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                  <private-number-select-search
                    [label]="fields + 'privateNumberId' | translate"
                    [control]="form?.get('privateNumberId')"
                    [value]="model.privateNumberId"
                    [sendType]="SendTypes.Single"
                    (itemChange)="onSelectPrivateNumber($event)"
                  >
                  </private-number-select-search>
                </div>

                <!-- senderPhonebookId -->
                <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                  <phonebook-select-search
                    type="phonebooksListForServices"
                    [label]="fields + 'senderPhonebookId' | translate"
                    [control]="form?.get('senderPhonebookId')"
                    [(value)]="model.senderPhonebookId"
                  >
                  </phonebook-select-search>
                </div>

                <!-- isSendActive -->
                <div
                  class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-py-2 tw-flex tw-justify-start tw-items-center"
                >
                  <mat-slide-toggle
                    formControlName="isActive"
                    [(ngModel)]="model.isActive"
                  >
                    {{ "common.isActive" | translate }}
                  </mat-slide-toggle>
                </div>

                <!-- start date time picker -->
                <app-periodic-date-time-picker
                  class="tw-w-full"
                  [config]="periodicDateTimeConfig"
                  (startDateTime)="model.startDateTime = $event"
                  (endDateTime)="model.endDateTime = $event"
                >
                </app-periodic-date-time-picker>
              </div>
            </details>

            <!-- Filter Conditions -->
            <details class="tw-px-4 tw-mt-5 tw-w-full" [open]="true">
              <summary
                class="active:tw-outline-none dark:tw-text-gray-300 focus:tw-outline-none tw-font-bold tw-mb-2 tw-text-[18px] tw-text-primary-700 tw-text-right"
              >
                {{ pageVocabs + "legends.competitionMatchOptions" | translate }}
              </summary>
              <div class="row tw-mt-8 2xl:tw-px-8">
                <div class="md:tw-w-2/3">
                  <base-parser-diagram
                    [formulas]="model.answers"
                    [diagramId]="'competitionDiagram'"
                    (selectedNode)="getCurrentAnswer($event)"
                    (newNode)="onAddOption($event)"
                    (removeNode)="onRemoveOption($event)"
                  ></base-parser-diagram>
                </div>

                <div class="md:tw-w-1/3">
                  <div class="row">
                    <!-- optionTitle -->
                    <div class="tw-w-full">
                      <form-field
                        class="tw-w-full"
                        [(value)]="currentAnswer.title"
                        [control]="form?.get('optionTitle')"
                        [label]="fields + 'optionTitle' | translate"
                      >
                      </form-field>
                    </div>

                    <!-- answerValue -->
                    <div class="tw-w-full">
                      <form-field
                        class="tw-w-full"
                        [(value)]="currentAnswer.answerValue"
                        [control]="form?.get('answerValue')"
                        [label]="fields + 'answerValue' | translate"
                      >
                      </form-field>
                    </div>

                    <!-- phonebookId -->
                    <div class="tw-w-full">
                      <phonebook-select-search
                        controlName="phonebookId"
                        [label]="fields + 'phonebookName' | translate"
                        type="phonebooksListForServices"
                        [value]="currentAnswer.phonebookId"
                        [control]="form?.get('phonebookId')"
                        (itemChange)="onChangeSelectPhonebook($event)"
                      >
                      </phonebook-select-search>
                    </div>

                    <!-- isCorrect -->
                    <div
                      class="sm:tw-w-1/6 md:tw-w-1/3 xl:tw-w-1/4 tw-py-2 tw-flex tw-justify-start tw-items-center"
                    >
                      <mat-slide-toggle
                        formControlName="isCorrect"
                        [(ngModel)]="currentAnswer.isCorrect"
                      >
                        {{ fields + "isCorrect" | translate }}
                      </mat-slide-toggle>
                    </div>
                  </div>
                  <div class="row tw-mt-8 2xl:tw-px-8">
                    <nav
                      ngbNav
                      #nav="ngbNav"
                      class="nav-tabs border-bottom tw-text-center tw-sticky tw-top-0 tw-z-[5] tw-bg-white dark:tw-bg-dark-300"
                      [destroyOnHide]="false"
                    >
                      <!-- *answerResponse -->
                      <ng-container [ngbNavItem]="'answerResponse'">
                        <a
                          ngbNavLink
                          class="tw-flex-center border bg-transparent"
                          style="flex: 1"
                        >
                          <span class="tw-mt-1 tw-mr-2 text-dark">{{
                            "common.answerResponse" | translate
                          }}</span>
                        </a>
                        <ng-template ngbNavContent>
                          <div class="tw-w-full">
                            <app-sms-body
                              [isEditMode]="formPageConfig.isEditMode"
                              [form]="form"
                              [smsBodyControlName]="'answerText'"
                              [senderNumberControlName]="'answerPrivateNumber'"
                              [isAddSignature]="false"
                              [isAddHeader]="false"
                              [isShowSmsTemplate]="false"
                              [senderNumberId]="
                                currentAnswer?.answerResponse?.privateNumber?.id
                              "
                              [smsBody]="currentAnswer?.answerResponse?.text"
                              [sendType]="SendTypes.Single"
                              (finalSmsBody)="onSetResponseText($event)"
                              (senderNumber)="
                                onSetResponsePrivateNumber($event)
                              "
                            >
                            </app-sms-body>
                          </div>
                        </ng-template>
                      </ng-container>

                      <!-- *duplicationResponse -->
                      <ng-container [ngbNavItem]="'duplicationResponse'">
                        <a
                          ngbNavLink
                          class="tw-flex-center border bg-transparent"
                          style="flex: 1"
                        >
                          <span class="tw-mt-1 tw-mr-2 text-dark"
                            >{{ "common.duplicationResponse" | translate }}
                          </span>
                        </a>

                        <ng-template ngbNavContent>
                          <div class="tw-w-full">
                            <app-sms-body
                              [isEditMode]="formPageConfig.isEditMode"
                              [form]="form"
                              [smsBodyControlName]="'duplicatedText'"
                              [senderNumberControlName]="
                                'duplicatedPrivateNumber'
                              "
                              [isAddSignature]="false"
                              [isAddHeader]="false"
                              [isShowSmsTemplate]="false"
                              [senderNumberId]="
                                currentAnswer?.duplicationResponse
                                  ?.privateNumber?.id
                              "
                              [smsBody]="
                                currentAnswer?.duplicationResponse?.text
                              "
                              [sendType]="SendTypes.Single"
                              (finalSmsBody)="
                                onSetDuplicatedResponseText($event)
                              "
                              (senderNumber)="
                                onSetDuplicatedResponsePrivateNumber($event)
                              "
                            >
                            </app-sms-body>
                          </div>
                        </ng-template>
                      </ng-container>

                      <!-- *notValidAnswersResponse -->
                      <ng-container [ngbNavItem]="'notValidAnswersResponse'">
                        <a
                          ngbNavLink
                          class="tw-flex-center border bg-transparent"
                          style="flex: 1"
                        >
                          <span class="tw-mt-1 tw-mr-2 text-dark"
                            >{{ "common.notValidAnswersResponse" | translate }}
                          </span>
                        </a>

                        <ng-template ngbNavContent>
                          <div class="tw-w-full">
                            <app-sms-body
                              [isEditMode]="formPageConfig.isEditMode"
                              [form]="form"
                              [smsBodyControlName]="
                                'notValidAnswersResponseText'
                              "
                              [senderNumberControlName]="
                                'notValidAnswersResponsePrivateNumber'
                              "
                              [isAddSignature]="false"
                              [isAddHeader]="false"
                              [isShowSmsTemplate]="false"
                              [senderNumberId]="
                                model?.notValidAnswersResponse?.privateNumber
                                  ?.id
                              "
                              [smsBody]="model?.notValidAnswersResponse?.text"
                              [sendType]="SendTypes.Single"
                              (finalSmsBody)="
                                onSetNotValidAnswersResponseText($event)
                              "
                              (senderNumber)="
                                onSetNotValidAnswersResponsePrivateNumber(
                                  $event
                                )
                              "
                            >
                            </app-sms-body>
                          </div>
                        </ng-template>
                      </ng-container>
                    </nav>
                    <div [ngbNavOutlet]="nav" class="tw-mt-2"></div>
                  </div>
                </div>
              </div>
            </details>
          </div>

          <!-- form btns-->
          <app-form-btns
            [loading]="loading"
            [form]="form"
            [isEdit]="formPageConfig.isEditMode"
            (onClose)="onClose()"
            (onSubmit)="onSubmit()"
          >
          </app-form-btns>
        </form>
      </fieldset>
    </section>
  </div>
</app-page-body>
